import React from 'react'

import { Helmet } from 'react-helmet'

import StoreBanner from '../components/store-banner'
import PrimaryButton from '../components/primary-button'
import FeatureCard from '../components/feature-card'
import TestimonialsCard from '../components/testimonials-card'
import StatsCard from '../components/stats-card'
import LinkIconButton from '../components/link-icon-button'
import './home.css'
import Footer from '../components/footer'

const Home = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>Ismailishq</title>
        <meta property="og:title" content="Ismailishq" />
      </Helmet>
      <div data-role="Header" className="home-header-container">
        <header className="home-header">
          <div className="home-logo1">
            <a href="https://ismailishq.com">
              <img
                alt="image"
                src="/logotype-dark.svg"
                className="home-image10"
              />
            </a>
          </div>
          <div className="home-menu1 modern-nav">
          <a href="/terms" className='modern-nav-link'><span className="home-text47" >Terms</span></a>
            <a href="/help" className='modern-nav-link'><span className="home-text48">Help</span></a>
            <a href="/privacy-policy" className='modern-nav-link'><span className="home-text49" href="/privacy-policy">Privacy Policy</span></a>
          </div>
          <div className="home-container11">
            <StoreBanner></StoreBanner>
          </div>
          <div data-role="BurgerMenu" className="home-burger-menu">
            <svg viewBox="0 0 1024 1024" className="home-menu2">
              <path d="M810.667 725.333h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
              <path d="M810.667 426.667h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
              <path d="M810.667 128h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
            </svg>
          </div>
        </header>
        <div data-role="MobileMenu" className="home-mobile-menu">
          <div className="home-top">
            <div className="home-logo2">
              <img
                alt="image"
                src="/logotype-dark.svg"
                className="home-image11"
              />
            </div>
            <div data-role="CloseMobileMenu" className="home-close-menu">
              <svg viewBox="0 0 1024 1024" className="home-icon15">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="home-mid">
            <a href="/terms"><span className="home-text47" >Terms</span></a>
            <a href="/help"><span className="home-text48">Help</span></a>
            <a href="/privacy-policy"><span className="home-text49">Privacy Policy</span></a>
          </div>
          <div className="home-bot">
            <div className="home-container12">
              <a
                href="https://www.instagram.com/ismaili_ishq?igsh=MXFueDViMHY2ODBmYw=="
                target="_blank"
                rel="noreferrer noopener"
                className="home-link5"
              >
                <div className="home-container38">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon25"
                  >
                    <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                  </svg>
                </div>
              </a>
              <a
                href="https://www.facebook.com/share/1afcYdBjxE/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link6"
              >
              <div className="home-container39">
                <svg
                  viewBox="0 0 24 24"
                  className="home-icon25"
                >
                  <path d="M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z" /></svg>
              </div>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link7 hidden"
              >
                <div className="home-container40">
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="home-icon29"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link8 hidden"
              >
                <div className="home-container41">
                  <svg viewBox="0 0 1024 1024" className="home-icon31">
                    <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="home-main">
        <div className="home-blur-background"></div>
        <div className="home-hero">
          <div className="home-container17">
            <h1 className="home-text22 Headline1">
              <span>Linking Hearts</span>
              <br></br>
              <span>Igniting Love</span>
            </h1>
            {/* <PrimaryButton button="Get Started"></PrimaryButton> */}
            <StoreBanner></StoreBanner>
          </div>
          <img alt="image" src="/iphonex-1200w.png" className="home-image12" />
        </div>
        <img
          alt="image"
          src="/turquoise-circle.svg"
          className="home-turquoise-cirble"
        />
        <img
          alt="image"
          src="/purple-circle.svg"
          className="home-purple-circle"
        />
        <img alt="image" src="/left.svg" className="home-left" />
        <img alt="image" src="/right.svg" className="home-right" />
      </div>
      <div className="home-clients hidden">
        <div className="home-divider1"></div>
        <img alt="image" src="/logo-1.svg" className="home-image13" />
        <img alt="image" src="/logo-4.svg" className="home-image14" />
        <img alt="image" src="/logo-3.svg" className="home-image15" />
        <img alt="image" src="/logo-5.svg" className="home-image16" />
        <img alt="image" src="/logo-6.svg" className="home-image17" />
        <div className="home-divider2"></div>
      </div>
      <div className="home-features1">
        <h2 className="Headline2 home-text26">Tailor-made features</h2>
        <span className="home-text27">
          <span className="home-text28">
          </span>
        </span>
        <div className="home-features2">
          <FeatureCard 
            cardTitle="Profile Creation" 
            text="Users can create personalized profiles by uploading photos, specifying personal attributes, and answering selected questions to showcase their personality and preferences."
          ></FeatureCard>
          <FeatureCard 
            imageSrc="/02.svg" 
            cardTitle="Real Time Notification" 
            text="Users receive instant notifications when they have a new match or message, ensuring timely communication and engagement."
          ></FeatureCard>
          <FeatureCard
            imageSrc="/03.svg"
            cardTitle="Free Messaging"
            text="Once matched, users can communicate through the app's messaging system without any additional cost, promoting open and accessible interaction."
          ></FeatureCard>
        </div>
      </div>
      <div className="home-testimonials hidden">
        <div className="home-container18">
          <div className="home-container19">
            <img alt="image" src="/quote-mark.svg" className="home-image18" />
            <h1 className="home-text29 Headline2">
              Real Stories from Real Customers
            </h1>
            <span>Get inspired by these stories.</span>
            <div className="home-container20">
              <TestimonialsCard imageSrc="/logo-4.svg"></TestimonialsCard>
            </div>
          </div>
          <div className="home-container21">
            <div className="home-container22">
              <TestimonialsCard
                src="/logo-1.svg"
                text="I used Landify and created a landing page for my startup within a week. The Landify UI Kit is simple and highly intuitive, so anyone can use it."
                text1="Jane Cooper"
                text2="CEO, Airbnb"
                imageSrc="/logo-1.svg"
              ></TestimonialsCard>
            </div>
            <div className="home-container23">
              <TestimonialsCard
                text="Landify saved our time in designing my company page."
                text1="Kristin Watson"
                text2="Co-Founder, FedEx"
                imageSrc="/logo-2.svg"
              ></TestimonialsCard>
            </div>
          </div>
        </div>
      </div>
      <div className="home-achievements hidden">
        <div className="home-container24">
          <h2 className="home-text31">
            <span className="home-text32">
              Our 18 years of
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
            <span>achievements</span>
          </h2>
          <span className="home-text35">
            With our super powers we have reached this
          </span>
        </div>
        <div className="home-container25">
          <div className="home-container26">
            <StatsCard
              number="10,000+"
              imageSrc="/01.svg"
              description="Downloads per day"
            ></StatsCard>
            <StatsCard
              number="2 Milion"
              imageSrc="/04.svg"
              description="Users"
            ></StatsCard>
          </div>
          <div className="home-container27">
            <StatsCard number="500+" description="Clients"></StatsCard>
            <StatsCard
              number="140"
              imageSrc="/07.svg"
              description="Countries"
            ></StatsCard>
          </div>
        </div>
      </div>
      <div className="home-feature1 hidden">
        <div className="home-container28">
          <img
            alt="image"
            src="/iphonex-1200w.png"
            image_src="/iphonex-1200w.png"
            className="home-image19"
          />
        </div>
        <div className="home-container29">
          <h3 className="Headline3">Headline</h3>
          <span className="home-text37 Lead1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Condimentum
            diam orci pretium a pharetra, feugiat cursus. Dictumst risus, sem
            egestas odio cras adipiscing vulputate. Nisi, risus in suscipit non.
            Non commodo volutpat, pharetra, vel.
          </span>
          {/* <LinkIconButton text="Get Started"></LinkIconButton> */}
        </div>
      </div>
      <div className="home-feature2 hidden">
        <div className="home-container30">
          <h2 className="Headline2 home-text38">
            Enter the world of all fashion trends
          </h2>
          <span className="home-text39 Lead1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Condimentum
            diam orci pretium a pharetra, feugiat cursus. Dictumst risus, sem
            egestas odio cras adipiscing vulputate. Nisi, risus in suscipit non.
            Non commodo volutpat, pharetra, vel.
          </span>
        </div>
        <img
          alt="image"
          src="https://images.unsplash.com/photo-1535157412991-2ef801c1748b?ixlib=rb-1.2.1&amp;q=85&amp;fm=jpg&amp;crop=entropy&amp;cs=srgb&amp;h=1000"
          image_src="/iphonex-1200w.png"
          className="home-image20"
        />
      </div>
      <div className="home-cta">
        <div className="home-container31">
          <div className="home-container32">
            <h2 className="Headline2 home-text40">
            Love Could Be One Swipe Away
            </h2>
            <span className="home-text41 Lead1">
              Download the app and Discover real connections and unforgettable moments. Whether it’s your soulmate 
  or someone who just gets you — your next great love story starts here.
            </span>
            <span className="home-text42 Subtitle2">
              <span className="home-text43">Get the App</span>
            </span>
            <StoreBanner></StoreBanner>
          </div>
          <div className="home-container33">
            <img
              alt="image"
              src="/iphonex-1200w.png"
              image_src="/iphonex-1200w.png"
              className="home-image21"
            />
            <img
              alt="image"
              src="/iphonex-1200w.png"
              image_src="/iphonex-1200w.png"
              className="home-image22"
            />
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
